import {
  Text,
  Button,
  SimpleGrid,
  Stack,
  Badge,
  Group,
  Divider,
  Title,
  Container,
} from "@mantine/core";
import { Trans } from "react-i18next";
import { useCart } from "../Cart/CartContext";
import classes from "./WelcomeBanner.module.css";
import drivelogo from "../../media/drive-logo.png";
import acadlogo from "../../media/acc-Academy.png";
import irdlogo from "../../media/iRdrive-logo.png";
import acedrivelogo from "../../media/acedrive.png";
import acdrivelogo from "../../media/acdrive.png";
import lmulogo from "../../media/LMUDRIVE.png";

const welcomeApps: { name: string; logo: string }[] = [
  { name: "LMU DRIVE",   logo: lmulogo },
  { name: "ACC DRIVE",   logo: drivelogo },
  { name: "ACC Academy", logo: acadlogo },
  { name: "iR DRIVE",    logo: irdlogo },
  { name: "ACE DRIVE",   logo: acedrivelogo },
  { name: "AC DRIVE",    logo: acdrivelogo },
];

function AppEntry({ name, logo }: { name: string; logo: string }) {
  return (
    <div className={classes.appEntry}>
      <img src={logo} alt={name} style={{ width: 32, height: 32, objectFit: "contain" }} />
      <Text size="sm" fw={600}>{name}</Text>
    </div>
  );
}

export function WelcomeBanner() {
  const { openCart } = useCart();

  return (
    <div className={classes.section}>
      <Container size="lg">
        <SimpleGrid cols={{ base: 1, sm: 2 }} spacing={60} verticalSpacing={40}>

          {/* Left: copy & CTA */}
          <Stack gap="md" justify="center">
            <Group gap="sm" align="center">
              <Badge color="orange" variant="filled" size="lg" tt="uppercase" radius="sm">
                <Trans i18nKey="cta.welcome.badge" />
              </Badge>
            </Group>

            <Title className={classes.title}>
              <Text
                fs="italic"
                fw={900}
                inherit
                variant="gradient"
                gradient={{ from: "#e8890c", to: "#f5c518" }}
              >
                <Trans i18nKey="cta.welcome.title" />
              </Text>
            </Title>

            <Text size="xl" fw={500}>
              <Trans i18nKey="cta.welcome.costs" />
            </Text>

            <Text size="sm">
              <Trans i18nKey="cta.welcome.duration" />
            </Text>

            <Text size="sm" fw={500}>
              <Trans i18nKey="cta.welcome.hint" />
            </Text>

            <Divider color="orange.4" variant="dashed" />

            <Text size="xs" fs="italic">
              <Trans i18nKey="cta.welcome.upgradeHint" />
            </Text>

            <Button
              color="orange"
              size="md"
              onClick={() => openCart('welcome')}
              style={{ alignSelf: "flex-start" }}
            >
              <Trans i18nKey="cta.welcome.checkout" />
            </Button>
          </Stack>

          {/* Right: app list */}
          <Stack gap="md" justify="center">
            <Text size="sm" fw={700} tt="uppercase">
              <Trans i18nKey="cta.welcome.validFor" />
            </Text>
            <div className={classes.appGrid}>
              {welcomeApps.map((app) => (
                <AppEntry key={app.name} name={app.name} logo={app.logo} />
              ))}
            </div>
          </Stack>

        </SimpleGrid>
      </Container>
    </div>
  );
}
